import { render } from "./TypeOperationSelectComponent.vue?vue&type=template&id=3fc8ffba&ts=true"
import script from "./TypeOperationSelectComponent.vue?vue&type=script&lang=ts"
export * from "./TypeOperationSelectComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
